import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { useLicense } from '../context/LicenseContext';

const LicenseBanner = () => {
  const { status, loading, showWarning, isAppBlocked } = useLicense();

  if (loading || !status) return null;

  if (isAppBlocked) {
    return (
      <div className="bg-red-600 text-white px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          <ShieldX className="h-4 w-4 shrink-0" />
          <span>
            {status.expired
              ? `Licence expirée le ${status.expiry}. L'application est bloquée.`
              : 'Aucune licence valide. L\'application est bloquée.'}
          </span>
        </div>
        <Link
          to="/license"
          className="text-xs font-medium bg-white/20 hover:bg-white/30 px-3 py-1 rounded transition-colors"
        >
          Gérer la licence
        </Link>
      </div>
    );
  }

  return null;
};

export default LicenseBanner;
